import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class HttpService {

	constructor(
		private http: HttpClient
	) { }

	private createHeaders(): HttpHeaders {
		let headers = new HttpHeaders()
			.set('Cache-Control', 'no-cache')
			.set('Content-Type', 'application/json');

		return headers;
	}

	get<T>(url: string): Observable<T> {
		const headers = this.createHeaders();
		return this.http.get<T>(url, { headers });
	}

	post<T>(url: string, data: any): Observable<T> {
		const headers = this.createHeaders();
		return this.http.post<T>(url, data, { headers });
	}

	put<T>(url: string, data: any): Observable<T> {
		const headers = this.createHeaders();
		return this.http.put<T>(url, data, { headers });
	}

	delete<T>(url: string): Observable<T> {
		const headers = this.createHeaders();
		return this.http.delete<T>(url, { headers });
	}

	/** Специален метод за Excel/PDF/файлови отговори */
	postBlob(url: string, body: any): Observable<HttpResponse<Blob>> {
		const headers = this.createHeaders();
		return this.http.post(url, body, {
			headers,
			observe: 'response',
			responseType: 'blob'
		});
	}

	/** GET вариант за Excel/PDF файлови отговори. */
	getBlob(url: string): Observable<HttpResponse<Blob>> {
		const headers = this.createHeaders();
		return this.http.get(url, {
			headers,
			observe: 'response',
			responseType: 'blob'
		});
	}

	/** 🔹 Нов метод – FormData upload (без Content-Type: application/json) */
	postFormData<T>(url: string, formData: FormData): Observable<T> {
		let headers = new HttpHeaders()
			.set('Cache-Control', 'no-cache');
		return this.http.post<T>(url, formData, { headers });
	}
}
